import { useState } from 'react';
import { signInWithRedirect } from 'aws-amplify/auth';
import {
  Container,
  Button,
  Alert,
  SpaceBetween,
  Box
} from '@cloudscape-design/components';

export const FederatedLoginForm = ({ onSwitchToLocal }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleFederatedSignIn = async () => {
    setLoading(true);
    setError('');

    try {
      // Redirect to Midway OIDC provider
      await signInWithRedirect({ 
        provider: { 
          custom: 'Midway' 
        } 
      });
    } catch (err) {
      setError(err.message || 'Federated sign in failed');
      setLoading(false);
    }
  };

  return (
    <Container>
      <SpaceBetween size="l">
        <Box textAlign="center">
          <Box variant="h1" fontSize="heading-xl" fontWeight="bold">
            ResearchIQ
          </Box>
        </Box>
        
        {error && (
          <Alert type="error" dismissible onDismiss={() => setError('')}>
            {error}
          </Alert>
        )}
        
        <Box textAlign="center">
          <SpaceBetween size="m">
            <Button
              variant="primary"
              loading={loading}
              onClick={handleFederatedSignIn}
              iconName="external"
            >
              Sign in with Midway
            </Button>
            
            <Box variant="small" color="text-body-secondary">
              You will be redirected to Midway for authentication
            </Box>

            {onSwitchToLocal && (
              <Button
                variant="normal"
                onClick={onSwitchToLocal}
              >
                Summit Login
              </Button>
            )}
          </SpaceBetween>
        </Box>
      </SpaceBetween>
    </Container>
  );
};